import { render, staticRenderFns } from "./app-registration-user-form.vue?vue&type=template&id=d8ecd396&"
import script from "./app-registration-user-form.vue?vue&type=script&lang=js&"
export * from "./app-registration-user-form.vue?vue&type=script&lang=js&"
import style0 from "./app-registration-user-form.vue?vue&type=style&index=0&id=d8ecd396&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports